<!-- 行业散点图 -->
<template>
  <div class="industry-point-chart">
    <!-- 顶部说明 -->
    <div class="tip row">
      <img src='https://img.1234567.com.cn/trade/2018102616580210.png' />
      <div class="tip-text">圆圈越大代表持仓占比越大</div>
    </div>
    <!-- 散点图 -->
    <div class="chart-container">
      <div v-for="(line, index) in pointList" :key="`point-line-${index}`" class="point-line row">
        <div class="type-title">{{line.type}}</div>
        <div
          v-for="(item, pIndex) in line.data"
          :key="`point-${index}-${pIndex}`"
          class="point-box row">
          <div :style="{
            width: `${item.size/2}px`,
            height: `${item.size/2}px`,
            borderRadius:`${item.size/4}px`,
            backgroundColor: item.color }"
            ></div>
        </div>
      </div>
      <!-- 日期 -->
      <div class="date-line row">
        <div style="flex:1"></div>
        <div v-for="(date, index) in dateArr" :key="`point-date-${index}`" class="date-text row"
          >{{date.range}}</div>
      </div>
      <!-- 选中 -->
      <div class="choose-box row" >
        <div style="flex:1" ></div>
        <div v-for="(date, index) in dateArr" :key="`point-date-${index}`"
          @click="clickPoint(index)"
          :style="{ opacity: chooseIndex === index && showColumns ?  1 : 0}"
          class="choose-line-box row">
          <div class="line"
          ></div>
          <div class="choose-date">{{date.range}}</div>
          <div
            v-if="chooseIndex === index && showColumns && !$isEmpty(chooseColumn)"
            class="choose-info"
            :style="getStyle(index)">
            <div v-for="(item, index) in chooseColumn" :key="index" class="choose-info-text"
              >{{`${item.type}：${item.value}`}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 更多 -->
    <div class="more">更多持仓特征</div>
  </div>
</template>

<script>
export default {
  name: 'industry-point-chart',

  props: {
    dataSource: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      pointList: [],
      dateArr: [], // 日期
      chooseColumn: [], // 选中列
      chooseIndex: 0, // 选中列Index
      showColumns: false, // 展示选中
    };
  },

  watch: {
    dataSource: {
      handler() {
        console.log('⭕️ dataSource', this.dataSource);
        if (!this.$isEmpty(this.dataSource)) {
          const tmpData = this.filterData(this.dataSource);
          this.pointList = this.handlePointData(tmpData);
          console.log('⭕️ pointList', this.pointList);
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {

    getStyle(index) {
      return index < 3 ? { left: 'calc(50% + 4px)' } : { right: 'calc(50% + 4px)' };
    },

    clickPoint(pIndex) {
      const columnData = [];
      this.pointList.forEach((line) => {
        if (!this.$isEmpty(line?.data[pIndex]) && line?.data[pIndex]?.size) {
          columnData.push({
            type: line.type,
            value: `${parseFloat(line?.data[pIndex]?.PCTNV)?.toFixed(2)}%` || '--',
          });
        }
      });
      this.chooseColumn = columnData;
      this.chooseIndex = pIndex;
      this.showColumns = true;
      setTimeout(() => {
        this.showColumns = false;
      }, 5000);
    },

    isYearOrHalf(date) {
      const dateArr = date.split('-');
      const month = dateArr[1];
      const day = dateArr[2];

      const specialDates = {
        '12-31': true,
        '09-30': false,
        '06-30': true,
        '03-31': false,
      };
      const key = `${month}-${day}`;
      return specialDates[key] || false;
    },
    handleDate(date) {
      const dateArr = date.split('-');
      const year = dateArr[0];
      // 年份保留后两位就够了
      const yy = year.toString().substr(2, 2);
      const month = dateArr[1];
      const day = dateArr[2];
      if (month === '12' && day === '31') {
        return `${yy}Q4`;
      }
      if (month === '09' && day === '30') {
        return `${yy}Q3`;
      }
      if (month === '06' && day === '30') {
        return `${yy}Q2`;
      }
      if (month === '03' && day === '31') {
        return `${yy}Q1`;
      }
      return date;
    },
    handlePointSize(percent) {
      const thresholds = [
        { threshold: 50, size: 36 },
        { threshold: 30, size: 32 },
        { threshold: 20, size: 28 },
        { threshold: 15, size: 22 },
        { threshold: 10, size: 18 },
        { threshold: 5, size: 12 },
        { threshold: 2.5, size: 8 },
        { threshold: 0.1, size: 4 },
      ];

      const thresholdObj = thresholds.find((obj) => percent >= obj.threshold);
      return thresholdObj ? thresholdObj.size : 0;
    },
    // 筛选数据 只要最新一期 + 前五期年报/半年报
    filterData(originData) {
      if (!originData || !Object.keys(originData).length) {
        return [];
      }
      const originArray = [];
      Object.keys(originData).forEach((range) => {
        originArray.push({
          date: range,
          data: originData[range],
        });
      });
      // 排序
      originArray.sort((a, b) => Date.parse(b.date.replace(/-/g, '/')) - Date.parse(a.date.replace(/-/g, '/')));
      const result = {};
      originArray.forEach((element, index) => {
        if (Object.keys(result).length < 6) {
          if (index === 0) {
            // 最新一期
            result[element.date] = element.data;
          } else if (this.isYearOrHalf(element.date)) {
            // 年报或者半年报
            result[element.date] = element.data;
          }
        }
      });
      return result;
    },

    handlePointData(data) {
      // 入参 符合条件的数据 {2022-06-30: [], 2022-03-31: []...}
      // 先把时间保存下来
      const timeList = Object.keys(data);
      console.log('timeList', timeList);
      // 获取数据中所有的主题
      const temp = Object.values(data).reduce(
        (prev, next) => [...prev, ...next.map((item) => item.TOPICCODE)],
        [],
      );
      const topicList = [...new Set(temp)];
      const configType = ['消费', '科技', '金融', '医药', '制造', '新能源', '周期', '基建地产'];
      // 主题小于6个 需要补全到6个 大于6个 展示全部
      if (topicList.length < 6) {
        // 获取缺少的主题
        const lackTopic = configType.filter((item) => topicList.indexOf(item) < 0);
        // 补全
        topicList.push(...lackTopic.splice(0, 6 - topicList.length));
      }
      const dateArr = [];
      // 根据主题列表 为每个时间段补齐数据
      timeList.forEach((time) => {
        dateArr.push({
          realDate: time,
          range: this.handleDate(time),
        });
        const timeData = data[time];
        const timeDataTopic = timeData.map((item) => item.TOPICCODE);
        topicList.forEach((topic) => {
          if (timeDataTopic.indexOf(topic) < 0) {
            data[time].push({
              TOPICCODE: topic,
              PCTNV: 0,
              REPORTDATE: time,
              FCODE: this.fundCode,
            });
          }
        });
      });
      this.dateArr = dateArr.sort((a, b) => (a.realDate > b.realDate ? 1 : -1));
      // 数据格式化
      const allData = [];
      // 把数据打散 按类型重新处理
      Object.keys(data).forEach((range) => {
        allData.push(...data[range]);
      });
      const listData = [];
      allData.forEach((item) => {
        // 分类
        const { TOPICCODE, PCTNV } = item;
        const index = listData.findIndex((ele) => ele?.type === TOPICCODE);
        const obj = {
          date: this.handleDate(item.REPORTDATE),
          size: this.handlePointSize(item.PCTNV),
          color: item.PCTNV > 20 ? '#FA5914' : '#FCD9CA',
          REPORTDATE: item.REPORTDATE,
          PCTNV,
        };
        if (index >= 0) {
          listData[index].data.push(obj);
          listData[index].total += Number(item.PCTNV) || 0;
        } else {
          listData.push({
            type: item.TOPICCODE,
            total: Number(item.PCTNV),
            data: [obj],
          });
        }
      });
      // 小于0.01的主题，当作不存在
      // listData = listData.filter((item) => {
      //   if (item.total > 0.01) {
      //     return item
      //   }
      // })

      return listData.map((item) => {
        item.data.sort((a, b) => (a.REPORTDATE > b.REPORTDATE ? 1 : -1));
        return item;
      });
    },

  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.industry-point-chart {
  width: 100%;
  .tip {
    justify-content: left;
    img {
      width: 26px;
      height: 26px;
    }
    .tip-text {
      font-size: 26px;
      color: #666666;
      line-height: 37px;
      margin-left: 12px;
    }
  }
  .chart-container {
    margin-top: 24px;
    position: relative;
    .point-line {
      padding: 14px 24px;
      box-sizing: border-box;
      width: 100%;
      background-color: #fafafa;
      border-radius: 4px;
      margin-bottom: 8px;
      .type-title {
        font-size: 24px;
        line-height: 36px;
        color: #000000;
        flex: 1;
      }
      .point-box {
        flex: 1;
        justify-content: center;
      }
    }
    .date-line {
      padding: 8px 24px 0;
      box-sizing: border-box;
      width: 100%;
      .date-text {
        flex: 1;
        justify-content: center;
        font-family: DINAlternate-Bold;
        font-size: 22px;
        color: #999999;
        line-height: 24px;
      }
    }
    .choose-box {
      position: absolute;
      padding: 0 24px;
      box-sizing: border-box;
      width: 100%;
      top: 0;
      bottom: 0;
      .choose-line-box {
        flex: 1;
        justify-content: center;
        height: 100%;
        position: relative;
        .line {
          border: 2px dashed red;
          height: 100%;
        }
        .choose-date {
          position: absolute;
          bottom: 0;
          background-color: red;
          border-radius: 12px;
          color: #ffffff;
          width: 100%;
          font-size: 22px;
          line-height: 24px;
          text-align: center;
        }
        .choose-info {
          width: fit-content;
          border: 1px solid rgba(250,89,20,0.39);
          background-color: #FFF3EC;
          position: absolute;
          border-radius: 8px;
          padding: 6px 8px;
          min-width: 180px;
          .choose-info-text {
            font-family: DINAlternate-Bold;
            font-size: 24px;
            line-height: 44px;
          }
        }
      }
    }
  }
  .more {
    line-height: 102px;
    font-size: 30px;
    color: #008AFF;
    text-align: center;
  }
}
</style>
